<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}
<!--<p-toast  position="center">
</p-toast>-->
<p-confirmDialog></p-confirmDialog>

<div class="pt-remove">

  <div [formGroup]="form1" >
    @if (type!=='Expense') {
      <div class="mx-0 my-2 justify-content-between align-items-center"
        [ngStyle]="{'background-color': getReservationStatusColor(reservation?.reservationStatus), 'color': getReservationStatusFontColor(reservation?.reservationStatus)}"
        >
        <div class="d-flex reservation-title align-items-center" [ngStyle]="{'color': getReservationStatusFontColor(reservation?.reservationStatus)}">
          <h2 class="m-0 py-1 fw-bold">
            <span style="font-weight: 800;" [ngStyle]="{'color': getReservationStatusFontColor(reservation?.reservationStatus)}">{{reservation?.guestProfile?.lastName || reservation?.guestName}} ({{reservation?.checkInDate | date: 'MM-dd-yyyy'}} - {{reservation?.checkOutDate | date: 'MM-dd-yyyy'}})</span>
          </h2>
          <!--<span> {{reservation?.numNights}} nights ({{reservationIndex}} of {{reservationCount}})</span>-->
        </div>
        <div class="col-sm-6">
          <div class="btn-groups text-md-end py-1">
            <!-- <button type="button" class="btn btn-light btnwhite">delete</button> -->
          </div>
        </div>
      </div>
    }

    <div class="m-0 gy-5 gy-lg-2 justify-content-between align-items-start search-tag-top">
      @if (reservation?.reservationId) {
        <div class="col-xl-6 tag-label search-tag">
          @for (tagJoinAPI of reservation.tagJoinAPIS; track tagJoinAPI) {
            <!--
              R4 — Tag color rendering on the owner-statement detail.
              The new Manage Tag Categories dialog is the single source of truth.
              tagJoinAPI.tagColor flows from TagVO.tagCategoryColor; when null the tag
              renders with default neutral styling. Admins assign colors per-category
              to opt in.
            -->
            <div class="text-label"
                 [ngStyle]="tagJoinAPI.tagColor ? {'border-color': tagJoinAPI.tagColor} : null">
              {{tagJoinAPI.name}}
            </div>
          }
        </div>
      }
      @if (reservation?.reservationId) {
        <div class="col-xl-6 tag-search">
          <div>
            <!-- <app-tag-join-select [tagSource]="90" [viewOnly]="true" [tagSourceId]="reservation.reservationId" tagType=8 (tagsSelectedEvent)="updateTagModified($event)">
          </app-tag-join-select>-->
        </div>
      </div>
    }
    @if (type !== 'Expense') {
      <div class="reservation guestinfo">
        <div  class="mb-3 mb-lg-4 floating-form">
          <div class="guest">
            <table class="statement-table-info">
              <thead>
                <tr>
                  <th>Reservation#</th>
                  <th>Guest</th>
                  <th>Status</th>
                  <th>CheckIn</th>
                  <th>CheckOut</th>
                  <th>Nights#</th>
                  <th>Paid Nights</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    @if (!openingReservation[reservation.reservationId]) {
                      <span (click)="openReservation(reservation,$event)" class="cursor-pointer link-text">{{reservation.reservationId}}</span>
                    }
                    @if (openingReservation[reservation.reservationId]) {
                      <span><i class="pi pi-spinner pi-spin"></i></span>
                    }
                  </td>
                  <td>{{reservation.guestName}}</td>
                  <td>{{getReservationStatus(reservation?.reservationStatus)}}</td>
                  <td>{{reservation.checkInDate | date: 'MM-dd-yyyy'}}</td>
                  <td>{{reservation.checkOutDate | date: 'MM-dd-yyyy'}}</td>
                  <td>{{reservation.numNights}}</td>
                  <td>{{reservation.paidNights}}</td>
                  <td><a tooltip="View reservation ledger" tooltipPosition="top" (click)="viewReservationLedger(reservation)"><i style="color: blue;" class="pi pi-info-circle"></i></a></td>
                </tr>
              </tbody>
            </table>
            <!-- <ul class="list-group list-group-horizontal mt-2 common-list-group">
            <li class="list-group-item list-group-label text-end">
              <div class="fw-bold text-black">Reservation Id :</div>
            </li>
            <li class="list-group-item w_364">
              <span class="p-float-label required-field w-100">
                {{reservation.reservationId}}
              </span>
            </li>
          </ul>
          <ul class="list-group list-group-horizontal mt-2 common-list-group">
            <li class="list-group-item list-group-label text-end">
              <div class="fw-bold text-black">Guest Name :</div>
            </li>
            <li class="list-group-item w-75">
              <div class="d-flex gap-2 flex-wrap">
                <div class="selectgroup w_96">
                  <span class="p-float-label required-field w-100">
                    {{reservation.guestName}}
                  </span>
                </div>
              </div>
            </li>
          </ul>
          <ul class="list-group list-group-horizontal mt-2 common-list-group">
            <li class="list-group-item list-group-label text-end">
              <div class="fw-bold text-black">CheckIn Date :</div>
            </li>
            <li class="list-group-item w_364">
              <span class="p-float-label required-field w-100">
                {{reservation.checkInDate | date: 'yyyy-MM-dd'}}
              </span>
            </li>
          </ul>
          <ul class="list-group list-group-horizontal mt-2 common-list-group">
            <li class="list-group-item list-group-label text-end">
              <div class="fw-bold text-black">CheckOut Date :</div>
            </li>
            <li class="list-group-item w_364">
              <span class="p-float-label required-field w-100">
                {{reservation.checkOutDate | date: 'yyyy-MM-dd'}}
              </span>
            </li>
          </ul>
          <ul class="list-group list-group-horizontal mt-2 common-list-group">
            <li class="list-group-item list-group-label text-end">
              <div class="fw-bold text-black">No of Nights :</div>
            </li>
            <li class="list-group-item w_364">
              <span class="p-float-label required-field w-100">
                {{reservation.numNights}}
              </span>
            </li>
          </ul>
          <ul class="list-group list-group-horizontal mt-2 common-list-group">
            <li class="list-group-item list-group-label text-end">
              <div class="fw-bold text-black">Paid Nights :</div>
            </li>
            <li class="list-group-item w_364">
              <span class="p-float-label required-field w-100">
                {{reservation.paidNights}}
              </span>
            </li>
          </ul> -->
        </div>
      </div>
    </div>
  }

  @if (type == 'Expense') {
    <div class="reservation guestinfo">
      <div  class="mb-3 mb-lg-4 floating-form">
        <div class="guest">
          <table class="statement-table-info">
            <thead>
              <tr>
                <th>Expense Id</th>
                <th>Expense Date</th>
                <th>Name</th>
                <th>Description</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{reservation.ownerStmtExpId}}</td>
                <td>{{reservation.expenseDate | date: 'yyyy-MM-dd'}}</td>
                <td>{{reservation.name}}</td>
                <td>{{reservation.description}}</td>
                <td><a (click)="findById(reservation)"><i style="color: blue;" class="pi pi-pencil"></i></a></td>
              </tr>
            </tbody>
          </table>
          <!-- <ul class="list-group list-group-horizontal mt-2 common-list-group">
          <li class="list-group-item list-group-label text-end">
            <div class="fw-bold text-black">Expense Id :</div>
          </li>
          <li class="list-group-item w_364">
            <span class="p-float-label required-field w-100">
              {{reservation.ownerStmtExpId}}
            </span>
          </li>
        </ul>
        <ul class="list-group list-group-horizontal mt-2 common-list-group">
          <li class="list-group-item list-group-label text-end">
            <div class="fw-bold text-black">Expense Date :</div>
          </li>
          <li class="list-group-item w-75">
            <div class="d-flex gap-2 flex-wrap">
              <div class="selectgroup w_96">
                <span class="p-float-label required-field w-100">
                  {{reservation.expenseDate | date: 'yyyy-MM-dd'}}
                </span>
              </div>
            </div>
          </li>
        </ul>
        <ul class="list-group list-group-horizontal mt-2 common-list-group">
          <li class="list-group-item list-group-label text-end">
            <div class="fw-bold text-black">Title :</div>
          </li>
          <li class="list-group-item w_364">
            <span class="p-float-label required-field w-100">
              {{reservation.title}}
            </span>
          </li>
        </ul>
        <ul class="list-group list-group-horizontal mt-2 common-list-group">
          <li class="list-group-item list-group-label text-end">
            <div class="fw-bold text-black">Description :</div>
          </li>
          <li class="list-group-item w_364">
            <span class="p-float-label required-field w-100">
              {{reservation.description}}
            </span>
          </li>
        </ul> -->
      </div>
    </div>
  </div>
}
<div>

  <!--<app-order-detail-list [showPagination]="false" [reservationId]="reservation?.reservationId" [checkInDate]="reservation?.checkInDate" [checkOutDate]="reservation?.checkOutDate"
  [shortTermRentalId]="reservation?.shortTermRental?.shortTermRentalId" (refreshOrder)="doRefreshOrder()" [orderId]="reservation?.order?.orderId" [ruReservationId]="reservation?.ruReservationId">
</app-order-detail-list>-->
<app-statement-detail-list [ownerStmtExp]="ownerStmtExp" [reservation]="reservation" [showPagination]="false" [reservationId]="reservation?.reservationId" [checkInDate]="reservation?.checkInDate" [checkOutDate]="reservation?.checkOutDate"
  [type]="type"
  [orderDetails]="reservation.ownerStmtDetails"   [shortTermRentalId]="shortTermRentalId" (refreshOrder)="doRefreshOrder()" [orderId]="reservation?.order?.orderId" [ruReservationId]="reservation?.ruReservationId">
</app-statement-detail-list>
<!--<div class="mt-3 change-log">
<div class="title border-bottom-1 mb-2 titleblue">
  <h4 class="m-0 text-black fw-bold">
    Change Log
  </h4>
</div>
<ul class="list-group list-group-horizontal mb-3">
  <li class="w-100">
    <textarea class="fixtextarea" class="form-control" rows="5" id="comment" name="text" [innerHTML]="filterText(reservation?.changeLog)" readonly="true">
    </textarea>
  </li>
</ul>
</div>-->
</div>


</div>
</div>

<!-- <div class="row mx-0 mb-3 justify-content-between tabletile" style="background-color: #6F1200;">
<div class="col-sm-6">
  <h2 class="text-white m-0 py-1 fw-bold">InvoIce</h2>
</div>
</div>

<div class="row mx-0y-5 gy-lg-0">
  <div class="col-lg-12 invoicetable">
    <div class="row m-0">
      <div class="col-lg-6 pr-5">
        <div class="table-responsive-xl">
          <table class="table table-bordered mb-3">
            <thead align="center">
              <tr>
                <th>
                  Property
                </th>
                <th>
                  Added
                </th>
                <th>
                  Desc
                </th>
                <th>
                  #
                </th>
                <th>
                  Cost
                </th>
                <th>
                  Total
                </th>
              </tr>
            </thead>
            <tbody align="right">
              <tr *ngFor="let orderDetail of reservation?.order?.orderInvoice?.orderDetails">
                <td>{{reservation?.shortTermRental?.propertyCode}}</td>
                <td>{{reservation?.order?.createDate | date:'MM-dd-yyyy'}}</td>
                <td>{{orderDetail?.name}}</td>
                <td>{{orderDetail?.quantity}}</td>
                <td style="text-align: right;">{{orderDetail?.listPrice | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                <td style="text-align: right;">{{orderDetail?.subTotal | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
              </tr>

              <tr>
                <td colspan="5">
                  <b>
                    Sub total :
                  </b>
                </td>
                <td>
                  {{totalAmounts | currency : 'USD' : 'symbol' : '1.2-2'}}
                </td>
              </tr>
              <tr></tr>
              <tr>
                <td colspan="5">
                  Total Taxes :
                </td>
                <td>
                  {{totalTaxes | currency : 'USD' : 'symbol' : '1.2-2'}}
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <b>
                    Grand total :
                  </b>
                </td>
                <td>
                  <b>
                    {{grandTotals | currency : 'USD' : 'symbol' : '1.2-2'}}
                  </b>
                </td>
              </tr>

              <tr></tr>

              <tr *ngIf="reservation?.order?.orderInvoice?.orderInvoiceDetails.length > 0">
                <td colspan="5">
                  {{reservation?.order?.orderInvoice?.orderInvoiceDetails[0]?.description}} {{reservation?.order?.orderInvoice?.orderInvoiceDetails[0]?.createDate | date:'MM-dd-yyyy'}} :
                </td>
                <td>
                  (${{reservation?.order?.orderInvoice?.orderInvoiceDetails[0]?.amount}})
                </td>
              </tr>
              <tr *ngIf="reservation?.order?.orderInvoice?.orderInvoiceDetails[0]?.amount == undefined">
                <td colspan="5">
                  Payments received as of {{reservation?.order?.createDate | date:'MM-dd-yyyy'}}
                </td>
                <td>
                  ($0.00)
                </td>
              </tr>


              <tr></tr>

              <tr>
                <td colspan="5">
                  <b>
                    Outstanding balance :
                  </b>
                </td>
                <td>
                  <b>
                    {{grandTotals + reservation?.order?.orderInvoice?.orderInvoiceDetails[0]?.amount | currency : 'USD' : 'symbol' : '1.2-2'}}
                  </b>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="text-start">
                  <b>
                    Payment due dates
                  </b>
                </td>
              </tr>

              <tr>
                <td colspan="5">
                  HKH-236 (10/05/2022 - 10/06/2022) reservation fee due 07/30/2022 :
                </td>
                <td>
                  $1,973.80
                </td>
              </tr>

              <tr></tr>

              <tr>
                <td colspan="5">
                  HKH-236 (10/05/2022 - 10/06/2022) balance due 08/21/2022 :
                </td>
                <td>
                  $1,973.79
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-lg-6">
        <ul class="list-group list-group-horizontal mb-3 lightbluebtn">
          <li class="list-group-item border-radius w-100">
            <ul class="d-flex flex-column w-100 m-0 list-unstyled gap-2">
              <li class="mr-2"><a href="#">View Contract</a></li>
              <li _ngcontent-niq-c450=""><a href="#">View Invoice</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="payment">
      <div class="title border-bottom-1 mb-2 titleblue">
        <h4 class="m-0 text-black fw-bold">
          Payment
        </h4>
      </div>
      <div class="table-responsive-xl paymentable">
        <table class="table table-bordered mb-3">
          <thead align="center">
            <tr>
              <th>
                More
              </th>
              <th>
                Apply to
              </th>
              <th>
                Initiated
              </th>
              <th>
                Received
              </th>
              <th>
                Amount
              </th>
              <th>
                Type
              </th>
              <th>
                Name
              </th>
              <th>
                Chk#
              </th>
              <th>
                Conf#
              </th>
              <th>
                Deposit A/C#
              </th>
              <th>
                Trx
              </th>
              <th>
                Guest Notes
              </th>
              <th>
                Private Notes
              </th>
              <th>
                <small class="fw-bold d-block text-center text-danger mt-2">
                  <mat-icon>close</mat-icon>
                </small>
              </th>
            </tr>
          </thead>
          <tbody align="right">
            <tr>
              <td>
                <select name="newurl2" class="form-select">
                  <option value="">Select...</option>
                  <option value="">View
                    pay conf
                  </option>
                  <option value="">Email paymnt rcvd</option>
                </select>
              </td>
              <td>
                <select name="applyToReservationId0" class="form-select">
                  <option value=""></option>
                  <option value="101697">HKH-236</option>
                </select>
              </td>
              <td>
                <input type="text" id="initiated" placeholder="" value="" name="text"
                  class="form-control">
                </td>
                <td>
                  <input type="text" id="Received" placeholder="" value="" name="text"
                    class="form-control">
                  </td>
                  <td>
                    <input type="text" id="Amount" placeholder="" value="" name="text"
                      class="form-control">
                    </td>
                    <td>
                      <select name="paymentReceivedType0" class="form-select">
                        <option value="" selected=""></option>
                        <option value="AH">ACH</option>
                        <option value="CA">Cash</option>
                        <option value="CH">Check</option>
                        <option value="CC">Check-certified</option>
                        <option value="PC">Check-personal</option>
                        <option value="CR">Credit card</option>
                        <option value="PP">Paypal</option>
                        <option value="CV">Credit Voucher</option>
                      </select>
                    </td>
                    <td>
                      <input type="text" id="Name" placeholder="" value="" name="text"
                        class="form-control">
                      </td>
                      <td>
                        <input type="text" id="chk" placeholder="" value="" name="text"
                          class="form-control">
                        </td>
                        <td>
                          <input type="text" id="Conf" placeholder="" value="" name="text"
                            class="form-control">
                          </td>
                          <td>
                            <select name="paymentProceedsDepositedToAccountIdentifier0" class="form-select">
                              <option value="" selected=""></option>
                              <option value="0008-191786">BOH - Real Estate Esc</option>
                              <option value="0007-705069">BOH - Activity Esc</option>
                              <option value="7195082883">Wells - KBM Resorts</option>
                              <option value="8123774583">Wells - KBM Maui</option>
                              <option value="6123021286">Wells - PGP</option>
                            </select>
                          </td>
                          <td>
                            <select name="type0" class="form-select">
                              <option value="5">ACH Authorized</option>
                              <option value="6">ACH Requested</option>
                              <option value="7">Check In Mail</option>
                              <option value="2" selected="">Payment Received</option>
                              <option value="4">Refund Issued</option>
                              <option value="8">Credit Voucher Applied</option>
                              <option value="9">Credit Card Voided</option>

                            </select>
                          </td>
                          <td>
                            <input type="text" id="Guest-Notes" placeholder="" value="" name="text"
                              class="form-control">
                            </td>
                            <td>
                              <input type="text" id="Private-Notes" placeholder="" value="" name="text"
                                class="form-control">
                              </td>
                              <td>
                                <div class="form-check lastcheckbox">
                                  <input class="form-check-input" type="checkbox" value=""
                                    id="flexCheckDefault" />
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="payment-attempts">
                        <div class="title border-bottom-1 mb-2 titleblue">
                          <h4 class="m-0 text-black fw-bold">
                            Payment attempts
                          </h4>
                        </div>
                        <div class="table-responsive-xl">
                          <table class="table table-bordered mb-3">
                            <thead align="center">
                              <tr>
                                <th>
                                  Date
                                </th>
                                <th>
                                  Amount
                                </th>
                                <th>
                                  Type
                                </th>
                                <th>
                                  Name
                                </th>
                                <th>
                                  Check#/Id
                                </th>
                                <th>
                                  Result
                                </th>
                                <th>
                                  Request
                                </th>
                                <th>
                                  Change Log
                                </th>
                              </tr>
                            </thead>
                            <tbody align="center">
                              <tr>
                                <td>
                                  <span>
                                    04-07-2022
                                  </span>
                                </td>
                                <td>
                                  <span>
                                    $2,105.49
                                  </span>
                                </td>
                                <td>
                                  <span>
                                    Credit Card
                                  </span>
                                </td>
                                <td>
                                  <span>
                                    Test Test
                                  </span>
                                </td>
                                <td>
                                  <span>
                                    xxx4114
                                  </span>
                                </td>
                                <td class="bg-success">
                                  <span>
                                    A
                                  </span>
                                </td>
                                <td>
                                  <span>
                                    AC
                                  </span>
                                </td>
                                <td colspan="4" class="text-start textsm">
                                  <span class="d-block">
                                    Thu 04-07-2022 10:15 AM PDT YUTER null (0) ::: Created by PEA YUTER
                                  </span>
                                  <span class="d-block">
                                    Thu 04-07-2022 10:15 AM PDT YUTER null (0) ::: Order #100914
                                  </span>
                                  <span class="d-block">
                                    Thu 04-07-2022 10:15 AM PDT YUTER null (0) ::: Reservation #101679
                                  </span>
                                  <span class="d-block">
                                    Thu 04-07-2022 10:15 AM PDT YUTER null (0) ::: TEST PAYMENT APPROVED:
                                    $2,105.49 Auth#123456789
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span>
                                    04-07-2022
                                  </span>
                                </td>
                                <td>
                                  <span>
                                    $2,105.49
                                  </span>
                                </td>
                                <td>
                                  <span>
                                    Credit Card
                                  </span>
                                </td>
                                <td>
                                  <span>
                                    Test Test
                                  </span>
                                </td>
                                <td>
                                  <span>
                                    xxx4114
                                  </span>
                                </td>
                                <td class="bg-success">
                                  <span>
                                    A
                                  </span>
                                </td>
                                <td>
                                  <span>
                                    AC
                                  </span>
                                </td>
                                <td colspan="4" class="text-start textsm">
                                  <span class="d-block">
                                    Thu 04-07-2022 10:15 AM PDT YUTER null (0) ::: Created by PEA YUTER
                                  </span>
                                  <span class="d-block">
                                    Thu 04-07-2022 10:15 AM PDT YUTER null (0) ::: Order #100914
                                  </span>
                                  <span class="d-block">
                                    Thu 04-07-2022 10:15 AM PDT YUTER null (0) ::: Reservation #101679
                                  </span>
                                  <span class="d-block">
                                    Thu 04-07-2022 10:15 AM PDT YUTER null (0) ::: TEST PAYMENT APPROVED:
                                    $2,105.49 Auth#123456789
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <ul _ngcontent-ibf-c450="" class="list-group list-group-horizontal w-100 mb-3 newsres gap-2">
                        <li class="list-group-item w_128 d-flex flex-column align-items-start">
                          <small class="fw-bold d-block text-black"> New Res :</small>
                          <select name="property" class="form-select">
                            <option value=""></option>
                            <option value="270">Baby Beach BAY-25</option>
                            <option value="39">Baby Beach BAY-35</option>
                            <option value="462">Black Bear Lodge BBL-251</option>
                            <option value="317">Black Bear Lodge BBL-351A *SUSPENDED!</option>
                            <option value="320">Black Bear Lodge BBL-351B *SUSPENDED!</option>
                            <option value="355">Black Bear Lodge BBL-351Combo</option>
                            <option value="414">Boulder Creek BCC-1101</option>
                            <option value="383">Copperbottom Inn CBI-101</option>
                            <option value="384">Copperbottom Inn CBI-102</option>
                            <option value="387">Copperbottom Inn CBI-103</option>
                            <option value="390">Copperbottom Inn CBI-104</option>
                            <option value="393">Copperbottom Inn CBI-202</option>
                            <option value="396">Copperbottom Inn CBI-205</option>
                            <option value="399">Copperbottom Inn CBI-207</option>
                            <option value="402">Copperbottom Inn CBI-307</option>
                            <option value="405">Copperbottom Inn CBI-311</option>
                            <option value="488">Kaanapali Shores EXTRA *SUSPENDED!</option>
                            <option value="461">Grand Champions GCH-134</option>
                            <option value="115">Honua Kai HKH-101</option>
                            <option value="276">Honua Kai HKH-144 *SUSPENDED!</option>
                            <option value="101">Honua Kai HKH-150</option>
                            <option value="145">Honua Kai HKH-151 *SUSPENDED!</option>
                            <option value="123">Honua Kai HKH-201</option>
                            <option value="49">Honua Kai HKH-203</option>
                            <option value="88">Honua Kai HKH-204</option>
                            <option value="443">Honua Kai HKH-211</option>
                            <option value="83">Honua Kai HKH-215 *SUSPENDED!</option>
                            <option value="25">Honua Kai HKH-216</option>
                            <option value="136">Honua Kai HKH-224 *SUSPENDED!</option>
                            <option value="73">Honua Kai HKH-225</option>
                            <option value="2">Honua Kai HKH-229</option>
                            <option value="1">Honua Kai HKH-236</option>
                            <option value="61">Honua Kai HKH-238</option>
                            <option value="149">Honua Kai HKH-240</option>
                            <option value="72">Honua Kai HKH-242</option>
                            <option value="97">Honua Kai HKH-247</option>
                            <option value="458">Honua Kai HKH-305</option>
                            <option value="80">Honua Kai HKH-318</option>
                            <option value="130">Honua Kai HKH-323</option>
                            <option value="3">Honua Kai HKH-338</option>
                            <option value="20">Honua Kai HKH-340 *SUSPENDED!</option>
                            <option value="139">Honua Kai HKH-341</option>
                            <option value="4">Honua Kai HKH-344</option>
                            <option value="258">Honua Kai HKH-348</option>
                            <option value="85">Honua Kai HKH-404 *SUSPENDED!</option>
                            <option value="5">Honua Kai HKH-406</option>
                            <option value="82">Honua Kai HKH-412</option>
                            <option value="296">Honua Kai HKH-415</option>
                            <option value="131">Honua Kai HKH-423</option>
                            <option value="146">Honua Kai HKH-425</option>
                            <option value="471">Honua Kai HKH-432 *SUSPENDED!</option>
                            <option value="287">Honua Kai HKH-434</option>
                            <option value="201">Honua Kai HKH-441</option>
                            <option value="121">Honua Kai HKH-442</option>
                            <option value="77">Honua Kai HKH-501 *SUSPENDED!</option>
                            <option value="122">Honua Kai HKH-503</option>
                            <option value="137">Honua Kai HKH-504</option>
                            <option value="33">Honua Kai HKH-510 *SUSPENDED!</option>
                            <option value="125">Honua Kai HKH-520</option>
                            <option value="64">Honua Kai HKH-526</option>
                            <option value="108">Honua Kai HKH-529</option>
                            <option value="119">Honua Kai HKH-537</option>
                            <option value="142">Honua Kai HKH-545</option>
                            <option value="103">Honua Kai HKH-546</option>
                            <option value="257">Honua Kai HKH-548 *SUSPENDED!</option>
                            <option value="21">Honua Kai HKH-550</option>
                            <option value="155">Honua Kai HKH-603</option>
                            <option value="282">Honua Kai HKH-609</option>
                            <option value="31">Honua Kai HKH-610 *SUSPENDED!</option>
                            <option value="86">Honua Kai HKH-620</option>
                            <option value="143">Honua Kai HKH-645</option>
                            <option value="54">Honua Kai HKH-648</option>
                            <option value="6">Honua Kai HKH-714</option>
                            <option value="128">Honua Kai HKH-732 *SUSPENDED!</option>
                            <option value="7">Honua Kai HKH-742</option>
                            <option value="26">Honua Kai HKH-746</option>
                            <option value="229">Honua Kai HKH-816</option>
                            <option value="74">Honua Kai HKH-822</option>
                            <option value="67">Honua Kai HKH-838 *SUSPENDED!</option>
                            <option value="129">Honua Kai HKH-925</option>
                            <option value="90">Honua Kai HKK-1029</option>
                            <option value="171">Honua Kai HKK-1032 *SUSPENDED!</option>
                            <option value="497">Honua Kai HKK-112</option>
                            <option value="93">Honua Kai HKK-113</option>
                            <option value="40">Honua Kai HKK-140</option>
                            <option value="27">Honua Kai HKK-201</option>
                            <option value="84">Honua Kai HKK-203</option>
                            <option value="57">Honua Kai HKK-205 *SUSPENDED!</option>
                            <option value="98">Honua Kai HKK-209</option>
                            <option value="174">Honua Kai HKK-210 *SUSPENDED!</option>
                            <option value="87">Honua Kai HKK-225</option>
                            <option value="511">Honua Kai HKK-229 *SUSPENDED!</option>
                            <option value="473">Honua Kai HKK-231</option>
                            <option value="8">Honua Kai HKK-234</option>
                            <option value="453">Honua Kai HKK-236</option>
                            <option value="66">Honua Kai HKK-239 *SUSPENDED!</option>
                            <option value="178">Honua Kai HKK-242</option>
                            <option value="269">Honua Kai HKK-245</option>
                            <option value="99">Honua Kai HKK-250</option>
                            <option value="279">Honua Kai HKK-302 *SUSPENDED!</option>
                            <option value="180">Honua Kai HKK-306</option>
                            <option value="92">Honua Kai HKK-309 *SUSPENDED!</option>
                            <option value="76">Honua Kai HKK-313 *SUSPENDED!</option>
                            <option value="106">Honua Kai HKK-318 *SUSPENDED!</option>
                            <option value="285">Honua Kai HKK-332</option>
                            <option value="9">Honua Kai HKK-334</option>
                            <option value="141">Honua Kai HKK-343</option>
                            <option value="107">Honua Kai HKK-344 *SUSPENDED!</option>
                            <option value="100">Honua Kai HKK-349</option>
                            <option value="10">Honua Kai HKK-420 *SUSPENDED!</option>
                            <option value="11">Honua Kai HKK-424</option>
                            <option value="152">Honua Kai HKK-439</option>
                            <option value="58">Honua Kai HKK-443</option>
                            <option value="47">Honua Kai HKK-445</option>
                            <option value="173">Honua Kai HKK-449</option>
                            <option value="68">Honua Kai HKK-450</option>
                            <option value="238">Honua Kai HKK-512</option>
                            <option value="117">Honua Kai HKK-513</option>
                            <option value="22">Honua Kai HKK-524</option>
                            <option value="24">Honua Kai HKK-608</option>
                            <option value="13">Honua Kai HKK-706</option>
                            <option value="35">Honua Kai HKK-729 *SUSPENDED!</option>
                            <option value="63">Honua Kai HKK-743 *SUSPENDED!</option>
                            <option value="60">Honua Kai HKK-812</option>
                            <option value="506">Honua Kai HKK-829</option>
                            <option value="124">Honua Kai HKK-839 *SUSPENDED!</option>
                            <option value="294">Honua Kai HKK-920</option>
                            <option value="288">Honua Kai HKK-922</option>
                            <option value="14">Honua Kai HKK-926</option>
                            <option value="300">Honua Kai HKL-10A *SUSPENDED!</option>
                            <option value="302">Honua Kai HKL-12A</option>
                            <option value="303">Honua Kai HKL-12B</option>
                            <option value="435">Honua Kai HKL-5B</option>
                            <option value="273">Honua Kai HKL-6B</option>
                            <option value="424">Honua Kai HKL-7C *SUSPENDED!</option>
                            <option value="312">Honua Kai HKL-8C</option>
                            <option value="455">Hale Ono Loa HOL-217</option>
                            <option value="428">Hale Ono Loa HOL-409</option>
                            <option value="366">In The Trees ITT-22</option>
                            <option value="15">Kaanapali Alii KAL-362 *SUSPENDED!</option>
                            <option value="429">Kapalua Bay Villas KBV-12B3</option>
                            <option value="110">Kapalua Bay Villas KBV-14G4</option>
                            <option value="59">Kapalua Bay Villas KBV-15B2 *SUSPENDED!</option>
                            <option value="133">Kapalua Bay Villas KBV-15B3</option>
                            <option value="364">Kapalua Bay Villas KBV-16G4</option>
                            <option value="494">Kapalua Bay Villas KBV-20B2</option>
                            <option value="375">Kapalua Bay Villas KBV-21G4 *SUSPENDED!</option>
                            <option value="372">Kapalua Bay Villas KBV-21G5 *SUSPENDED!</option>
                            <option value="468">Kapalua Bay Villas KBV-26B1 *SUSPENDED!</option>
                            <option value="165">Kapalua Bay Villas KBV-28G2</option>
                            <option value="425">Kapalua Bay Villas KBV-29G5</option>
                            <option value="43">Kapalua Bay Villas KBV-30G2</option>
                            <option value="419">Kapalua Bay Villas KBV-32B2</option>
                            <option value="422">Kapalua Bay Villas KBV-32B3</option>
                            <option value="313">Kapalua Bay Villas KBV-34B2 *SUSPENDED!</option>
                            <option value="215">Kapalua Bay Villas KBV-34B3 *SUSPENDED!</option>
                            <option value="105">Kapalua Bay Villas KBV-36G2 *SUSPENDED!</option>
                            <option value="218">Kapalua Bay Villas KBV-37B3</option>
                            <option value="116">Kaanapali Coffee Farms KCF-907 *SUSPENDED!</option>
                            <option value="127">Kapalua Golf Villas KGV-11T2 *SUSPENDED!</option>
                            <option value="30">Kapalua Golf Villas KGV-14P6</option>
                            <option value="138">Kapalua Golf Villas KGV-14T6</option>
                            <option value="144">Kapalua Golf Villas KGV-14V1 *SUSPENDED!</option>
                            <option value="78">Kapalua Golf Villas KGV-16P3</option>
                            <option value="240">Kapalua Golf Villas KGV-16T4</option>
                            <option value="297">Kapalua Golf Villas KGV-17P7 *SUSPENDED!</option>
                            <option value="161">Kapalua Golf Villas KGV-17T4 *SUSPENDED!</option>
                            <option value="226">Kapalua Golf Villas KGV-19P2</option>
                            <option value="46">Kapalua Golf Villas KGV-19P3</option>
                            <option value="179">Kapalua Golf Villas KGV-19T1</option>
                            <option value="248">Kapalua Golf Villas KGV-19T3 *SUSPENDED!</option>
                            <option value="220">Kapalua Golf Villas KGV-19T6 *SUSPENDED!</option>
                            <option value="207">Kapalua Golf Villas KGV-21P2</option>
                            <option value="438">Kapalua Golf Villas KGV-21P3</option>
                            <option value="476">Kapalua Golf Villas KGV-22T5</option>
                            <option value="148">Kapalua Golf Villas KGV-23P2</option>
                            <option value="261">Kapalua Golf Villas KGV-24P2</option>
                            <option value="112">Kapalua Golf Villas KGV-24P7</option>
                            <option value="34">Kapalua Golf Villas KGV-25P3</option>
                            <option value="254">Kapalua Golf Villas KGV-25P6</option>
                            <option value="459">Kapalua Golf Villas KGV-25T4</option>
                            <option value="79">Kapalua Golf Villas KGV-26P6 *SUSPENDED!</option>
                            <option value="251">Kapalua Golf Villas KGV-27P6</option>
                            <option value="175">Kapalua Golf Villas KGV-27P7</option>
                            <option value="19">Kaanapali Royal KRO-H301 *SUSPENDED!</option>
                            <option value="16">Kaanapali Royal KRO-Q102</option>
                            <option value="126">Kapalua Ridge Villas KRV-1021 *SUSPENDED!</option>
                            <option value="95">Kapalua Ridge Villas KRV-224 *SUSPENDED!</option>
                            <option value="492">Kapalua Ridge Villas KRV-2823</option>
                            <option value="489">Kapalua Ridge Villas KRV-514</option>
                            <option value="465">Kapalua Ridge Villas KRV-722</option>
                            <option value="160">Kaanapali Shores KS-155</option>
                            <option value="132">Kaanapali Shores KS-257</option>
                            <option value="102">Kaanapali Shores KS-258</option>
                            <option value="118">Kaanapali Shores KS-455 *SUSPENDED!</option>
                            <option value="89">Kaanapali Shores KS-460 *SUSPENDED!</option>
                            <option value="485">Kaanapali Shores KS-535</option>
                            <option value="482">Kahana Villa KVR-E704</option>
                            <option value="432">Lift Lodge LLC-103</option>
                            <option value="477">Lahaina Shores LSH-117</option>
                            <option value="113">Mahana MAH-116 *SUSPENDED!</option>
                            <option value="96">Mahana MAH-1211</option>
                            <option value="232">Mahana MAH-312 *SUSPENDED!</option>
                            <option value="235">Mahana MAH-319 *SUSPENDED!</option>
                            <option value="163">Mahana MAH-419</option>
                            <option value="134">Mahana MAH-606 *SUSPENDED!</option>
                            <option value="157">Mahana MAH-609 *SUSPENDED!</option>
                            <option value="50">Mahana MAH-611</option>
                            <option value="411">Montage Kapalua Bay Montage-Ani *SUSPENDED!</option>
                            <option value="408">Montage Kapalua Bay Montage-Anuenue</option>
                            <option value="496">Montage Kapalua Bay Montage-Gaymon *SUSPENDED!</option>
                            <option value="51">Montage Kapalua Bay Montage-Ginger *SUSPENDED!</option>
                            <option value="71">Montage Kapalua Bay Montage-Kealoha *SUSPENDED!</option>
                            <option value="52">Montage Kapalua Bay Montage-King-Protea *SUSPENDED!</option>
                            <option value="479">Montage Kapalua Bay Montage-Luna</option>
                            <option value="281">Montage Kapalua Bay Montage-Makana *SUSPENDED!</option>
                            <option value="70">Montage Kapalua Bay Montage-Malia *SUSPENDED!</option>
                            <option value="311">Montage Kapalua Bay Montage-Molokai</option>
                            <option value="53">Montage Kapalua Bay Montage-Orchid *SUSPENDED!</option>
                            <option value="278">Montage Kapalua Bay Montage-Palapala</option>
                            <option value="316">Montage Kapalua Bay Montage-Waverider *SUSPENDED!</option>
                            <option value="210">Napili Point NAP-B39</option>
                            <option value="347">Napili Point NAP-B43</option>
                            <option value="81">Napili Point NAP-C18</option>
                            <option value="245">Napili Point NAP-C2 *SUSPENDED!</option>
                            <option value="264">Napili Point NAP-C39 *SUSPENDED!</option>
                            <option value="168">Napili Point NAP-C40 *SUSPENDED!</option>
                            <option value="358">Napili Point NAP-C42</option>
                            <option value="305">Napili Point NAP-C43</option>
                            <option value="441">Napili Shores NAS-B214</option>
                            <option value="503">Napili Shores NAS-F248</option>
                            <option value="91">Nohonani Condos NOH-400 *SUSPENDED!</option>
                            <option value="352">Private Home PAC-2410</option>
                            <option value="335">Private Home PGE-2413</option>
                            <option value="308">Papakea PKA-105 *SUSPENDED!</option>
                            <option value="37">Papakea PKH-205</option>
                            <option value="344">Private Home PLA-1155</option>
                            <option value="509">The Lookout PLO-6590 *SUSPENDED!</option>
                            <option value="423">The Lookout PLO-6599 *SUSPENDED!</option>
                            <option value="329">Private Home PNF-860</option>
                            <option value="332">Private Home POA-504B</option>
                            <option value="223">Polo Beach Club POL-109</option>
                            <option value="449">Private Home PPS-1416</option>
                            <option value="452">Private Home PPS-1418</option>
                            <option value="380">Private Home PRH-685</option>
                            <option value="341">Private Home PSD-2071</option>
                            <option value="246">Puamana PUAMANA-10-3 *SUSPENDED!</option>
                            <option value="267">Honua Kai RESERVED *SUSPENDED!</option>
                            <option value="417">Red Pine RPT-14T</option>
                            <option value="291">Honua Kai Test 1 *SUSPENDED!</option>
                            <option value="293">Honua Kai Test 2 *SUSPENDED!</option>
                            <option value="369">Town Pointe TPC-102C</option>
                            <option value="323">Timber Wolf Lodge TWL-12C</option>
                            <option value="326">Timber Wolf Lodge TWL-5B</option>
                            <option value="338">Vintage on the Strand VIN-17</option>
                            <option value="204">Wailea Elua Village WEV-2103</option>
                            <option value="500">Whaler WH1-1218</option>
                            <option value="111">Whaler WH2-1060 *SUSPENDED!</option>
                            <option value="508">Whaler WH2-1169 *SUSPENDED!
                            </option>
                          </select>
                        </li>
                        <li class="list-group-item w_128 d-flex flex-column align-items-start">
                          <small class="fw-bold d-block text-black"> In:</small>
                          <input type="text" placeholder="" value="" name="text" class="form-control">
                        </li>
                        <li class="list-group-item w_128 d-flex flex-column align-items-start">
                          <small class="fw-bold d-block text-black"> Out:</small>
                          <input type="text" placeholder="" value="" name="text" class="form-control">
                        </li>
                        <li class="list-group-item w_87 d-flex flex-column align-items-start">
                          <small class="fw-bold d-block text-black"> Guests:</small>
                          <div class="row m-0">
                            <select name="adults" class="form-select">
                              <option value="" selected=""></option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                            </select>
                            <span class="text-center" style="width:32px;">/</span>
                            <select name="adults" class="form-select">
                              <option value="" selected=""></option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                            </select>
                          </div>
                        </li>
                        <li class="list-group-item w_128 d-flex flex-column align-items-start">
                          <small class="fw-bold d-block text-black"> Email:</small>
                          <input type="text" placeholder="" value="" name="text" class="form-control">
                        </li>
                        <li class="list-group-item align-items-end lookie-btn">
                          <button type="button" class="btn btn-primary btn-sm">Lookie</button>
                        </li>
                      </ul>
                    </div>
                  </div> -->
                  <!-- <div class="mb-3 row mx-0 align-items-center justify-content-between" style="background-color: #F0F2FF;">
                  <div class="col-sm-12 p-0 leftbtn">
                    <div class="btn-groups mb-sm-0 mb-md-0 mb-lg-0 p-2">
                      <button type="button" class="btn btn-primary" (click)="updateReservation()">Update</button>
                      <button type="button" class="btn btn-light ml-2" [mat-dialog-close]="true"
                      (click)="gotoReservation()">Cancel</button>
                    </div>
                  </div>
                </div> -->
              </div>
            <!--</div>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>-->


    <!-- <p-dialog class="payment-popup" header="PAYMENT" [(visible)]="visible" [modal]="true" [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <div class="mb-2 d-flex justify-content-end">
      <div class="payment-icons">
        <img src="../../../assets/images/payment-icon/visa.svg">
        <img src="../../../assets/images/payment-icon/mastercard.svg">
        <img src="../../../assets/images/payment-icon/american-express-1.svg">
        <img src="../../../assets/images/payment-icon/discover-4.svg">
      </div>
    </div>
    <div [formGroup]="form2" class="forms w-100 d-block">
      <div formGroupName="paymentSource" class="floating-form">
        <div class="row">
          <div class="col-12">
            <span class="p-float-label w-100">
              <p-dropdown class="w-100" [options]="paymentSources" formControlName="paymentSourceId" (onChange)="selectPaymentSource($event)" optionLabel="name" optionValue="value"
                [filter]="true" filterBy="name"
              placeholder="Source Account"></p-dropdown>
              <label for="paymentSourceId">Source Account</label>
              <span *ngFor="let validation of validationMessages1.paymentSourceId">
                <small class="p-invalid"
                  *ngIf="form2.get('paymentSource.paymentSourceId').hasError(validation.type) && (form2.get('paymentSource.paymentSourceId').dirty || form2.get('paymentSource.paymentSourceId').touched)">{{validation.message}}
                </small>
              </span>
            </span>
          </div>

          <div class="col-6">
            <span class="p-float-label w-100">
              <p-dropdown class="w-100" [options]="paymentCreditCardRequests" formControlName="paymentCreditCardRequestedTransactionType" optionLabel="name" optionValue="value"
              placeholder="Action"></p-dropdown>
              <label for="paymentCreditCardRequestedTransactionType">Action</label>
              <span *ngFor="let validation of validationMessages1.paymentCreditCardRequestedTransactionType">
                <small class="p-invalid"
                  *ngIf="form2.get('paymentSource.paymentCreditCardRequestedTransactionType').hasError(validation.type) && (form2.get('paymentSource.paymentCreditCardRequestedTransactionType').dirty || form2.get('paymentSource.paymentCreditCardRequestedTransactionType').touched)">{{validation.message}}
                </small>
              </span>
            </span>
          </div>
          <div class="col-6"></div>
          <div class="col-6">
            <span class="p-float-label w-100">
              <input formControlName="paymentAmount" id="paymentAmount" type="text" pInputText>
              <label for="paymentAmount">Payment Amount $</label>
            </span>
            <span *ngFor="let validation of validationMessages1.paymentAmount">
              <small class="p-invalid"
                *ngIf="form2.get('paymentSource.paymentAmount').hasError(validation.type) && (form2.get('paymentSource.paymentAmount').dirty || form2.get('paymentSource.paymentAmount').touched)">{{validation.message}}
              </small>
            </span>
          </div>
          <div class="col-6"></div>
          <div class="col-12">
            <span class="p-float-label">
              <input name="cardName" formControlName="cardName" type="text" pInputText>
              <label for="cardName">Name on Card</label>
            </span>
            <div *ngFor="let validation of validationMessages1.cardName">
              <small *ngIf="form2.get('paymentSource.cardName').hasError(validation.type) && (form2.get('paymentSource.cardName').dirty || form2.get('paymentSource.cardName').touched)"
              class="p-error">{{validation.message}}</small>
            </div>
          </div>
          <div class="col-12">
            <span class="p-float-label">
              <input name="cardNumber" formControlName="cardNumber" minlength="15" maxlength="19" type="text" pInputText>
              <label for="cardNumber">Credit or Card Number</label>
            </span>
            <div *ngFor="let validation of validationMessages1.cardNumber">
              <small *ngIf="form2.get('paymentSource.cardNumber').hasError(validation.type) && (form2.get('paymentSource.cardNumber').dirty || form2.get('paymentSource.cardNumber').touched)"
              class="p-error">{{validation.message}}</small>
            </div>
          </div>
          <div class="col-6 arrive-info--dropdown">
            <span class="p-float-label">
              <p-dropdown formControlName="cardExpirationMonth" name="cardExpirationMonth" [autoDisplayFirst]="false" [options]="months" optionLabel="name" optionValue="value">
              </p-dropdown>
              <label for="cardNumber">Exp Month</label>
            </span>
            <div *ngFor="let validation of validationMessages1.cardExpirationMonth">
              <small
                *ngIf="form2.get('paymentSource.cardExpirationMonth').hasError(validation.type) && (form2.get('paymentSource.cardExpirationMonth').dirty || form2.get('paymentSource.cardExpirationMonth').touched)"
              class="p-error">{{validation.message}}</small>
            </div>
          </div>
          <div class="col-6 arrive-info--dropdown">
            <span class="p-float-label">
              <p-dropdown formControlName="cardExpirationYear" name="cardExpirationYear" [autoDisplayFirst]="false" [options]="years" optionLabel="name" optionValue="value">
              </p-dropdown>
              <label for="cardNumber">Exp Year</label>
            </span>
            <div *ngFor="let validation of validationMessages1.cardExpirationYear">
              <small
                *ngIf="form2.get('paymentSource.cardExpirationYear').hasError(validation.type) && (form2.get('paymentSource.cardExpirationYear').dirty || form2.get('paymentSource.cardExpirationYear').touched)"
              class="p-error">{{validation.message}}</small>
            </div>
          </div>
          <div class="col-6">
            <span class="p-float-label">
              <input name="cardSecurityCode" formControlName="cardSecurityCode" minlength="3" maxlength="4" type="text" pInputText>
              <label for="cardSecurityCode">Security code</label>
            </span>
            <div *ngFor="let validation of validationMessages1.cardSecurityCode">
              <small *ngIf="form2.get('paymentSource.cardSecurityCode').hasError(validation.type) && (form2.get('paymentSource.cardSecurityCode').dirty || form2.get('paymentSource.cardSecurityCode').touched)"
              class="p-error">{{validation.message}}</small>
            </div>
          </div>
          <div class="col-6 mb-lg-0 position-relative">
            <span class="p-float-label">
              <input name="postalCode" formControlName="postalCode" type="text" pInputText>
              <label for="postalCode">Postal code</label>
            </span>
            <div *ngFor="let validation of validationMessages1.postalCode" style="display: block; height: fit-content; position: relative;">
              <small *ngIf="form2.get('paymentSource.postalCode').hasError(validation.type) && (form2.get('paymentSource.postalCode').dirty || form2.get('paymentSource.postalCode').touched)" class="p-error"
              style="left: 10px;">{{validation.message}}</small>
            </div>
          </div>

        </div>

        <div class="mb-2">
          <h3 class="mb-3 step-inner-title text-capitalize">Terms</h3>
          <div class="position-relative mb-2">
            <div class="d-flex justify-content-start align-items-center">
              <div class="form-check form-switch">
                <input mdbCheckbox formControlName="iAgree" (click)="checkedIAgree($event, 'iAgree')" class="form-check-input" type="checkbox" id="flexSwitchCheckDefault2" />
              </div>
              <p class="mb-0 sm-text ms-2">I have read and
                understand the
                <a class="text text-decoration-underline">terms
                & cancellation policy</a>.
              </p>
            </div>
            <div *ngFor="let validation of validationMessages1.iAgree">
              <small *ngIf="isGuestAgreeForCreditCard" class="pt-1 p-error position-relative bottom-0 start-0" style="font-size: 0.75rem;">{{validation.message}}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row reservation-btn">
      <div class="col-12">
        <div class="d-flex justify-content-end flex-column-reverse flex-lg-row">
          <button class="mb-3 btn btn-orange step-form-btn text-capitalize mb-lg-0 w-100 w-md-auto" (click)="makeAdditionalPayment()" [disabled]="disabledBookReservationButton"
            style="border-color: #299A01 !important; background-color: #299A01 !important; background: #299A01 !important;">Make Payment
          </button>
        </div>
      </div>
    </div>
  </p-dialog>
  <p-dialog header="PAYMENT" [(visible)]="showPaymentSuccess" [modal]="true" [draggable]="false" [resizable]="true">
    <section class="thankyou_messag">
      <div class="container">
        <div class="d-flex justify-content-center align-items-center flex-column mb-3">
          <i class="pi pi-check-circle me-3" style="font-size:5em;color:green"></i>
          <h3>Payment success, thank you.</h3>

          <p>Please click on ok button for update invoice.</p>
          <div class="cancle-btn">
            <button class="btn btn-cancle btn-orange" (click)="closePaymentDialog()">OK</button>
          </div>
        </div>
      </div>

    </section>
  </p-dialog> -->
